export default __webpack_public_path__ + "static/media/stop-small.6b00710c.svg";